module.exports = __webpack_public_path__ + "img/category_thumbnail.dda62d7c.jpeg";